import AbstractPageBaseController from '../../../../../core/abstracts/controllers/page-controller';

export default class AbstractSmsTemplatesEditorPageCtrl extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector)

        this.params = this.injector.get('$stateParams');
        this.api = this.injector.get('$http');
        this.state = this.injector.get('$state');
        this.alert = this.injector.get('Alert');

        this.aceOptions = {};
        this.injector.get('AceEditor').getEditor((editor) => this.aceOptions = editor);

        this.availableFromNumbers = this.getAvailableFromNumbers()
            .map((entry) => {
                return {
                    value: entry.value,
                    label: entry.title
                }
            });

        this.model = {
            name: '',
            from_number: this.availableFromNumbers[0] ? this.availableFromNumbers[0].value : null,
            content: ''
        }

        this.messageValidation = {
            isGsm: true,
            limit: 140,
            length: 0,
            smsCount: 0
        };

        this.scope.$watch(
            () => this.model.content,
            () => {
                let gsm = "@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞ^{}\[~]|€ÆæßÉ!\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà\n ",
                    gsmDoubleBytes = '€~{}[]^|\\',
                    gsmCheck = true,
                    strLengthPerChar = 0,
                    strLengthGsm = 0;

                for (let i = 0, n = this.model.content.length; i < n; i++) {
                    strLengthPerChar++;
                    strLengthGsm++;
                    let curChar = this.model.content[i];
                    if (gsm.indexOf(curChar) !== -1) {
                        if (gsmDoubleBytes.indexOf(curChar) !== -1) {
                            strLengthGsm++;
                        }
                    } else {
                        gsmCheck = false;
                    }
                }

                if (gsmCheck) {
                    this.messageValidation = {
                        isGsm: true,
                        limit: 140,
                        length: strLengthGsm,
                        smsCount: (strLengthGsm > 0) ? Math.ceil(strLengthGsm / 140) : 0
                    };
                } else {
                    this.messageValidation = {
                        isGsm: false,
                        limit: 70,
                        length: strLengthPerChar,
                        smsCount: (strLengthPerChar > 0) ? Math.ceil(strLengthPerChar / 70) : 0
                    };
                }
            }
        );
    }

    getAvailableFromNumbers() {
        try {
            return this.injector.get('Users').state.loggedin.profile.company.data.settings.messages.sms_sender_names;
        } catch (e) {
            return []
        }
    }

    updateSelectedFromNumber(newVal) {
        this.model.from_number = newVal
    }

    async save() {
        try {
            await this.handleSubmitData()
            this.alert.success(
                'success',
                'title'
            )
            this.state.go('app.messages.sms.templates.index');
        } catch(e) {
            this.alert.handle(e)
        }
    }

    cancel() {
        this.state.go('app.messages.sms.templates.index');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/pages/sms/templates/abstract-editor.js